import {
  DEVICES_CHANGE
} from "../constants/ActionTypes";

const INIT_STATE = {
  value:{}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEVICES_CHANGE:
      return {...state,value:action.payload};
    default:
      return state;
  }
}
